import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { ButtonEnums } from '../button/index.ts';
import { JustifyContent } from './dropdown.props.ts';
import { enumAttributeConverter } from '../enum-types.ts';
import { mergeJustifyContent } from '../justify-content.ts';

import * as TagNames from './dropdown.tagnames.ts';
import { DropDownItemClickEvent } from './dropdown.events.ts';
import { AtlButtonTemplate } from '../button/button.component.ts';

@customElement(TagNames.DropdownItem)
export class AtlDropdownItem extends LitElement {
   declare dropdownLabel: string;
   declare iconName: string;
   declare reverseOrder: boolean;
   declare justifyContent: JustifyContent;
   declare disableAutoClose?: boolean;

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: flex;
            align-items: stretch;
            cursor: pointer;
         }
            
         .btn {
            color: var(--tti-dropdown-item-text);
         }
      `,
   ];

   static properties = {
      dropdownLabel: { type: String, attribute: 'dropdown-label' },
      iconName: { type: String, attribute: 'icon-name' },
      reverseOrder: { type: Boolean, attribute: 'reverse-order' },
      justifyContent: {
         type: String,
         attribute: 'justify-content',
         converter: enumAttributeConverter(JustifyContent),
      },
      disableAutoClose: { type: Boolean, attribute: 'disable-auto-close' },
   };

   render() {
      return html`
         <div
            class=${classMap(mergeJustifyContent(
               { 'dropdown-item': true, 'd-flex': !!this.justifyContent },
               this.justifyContent
            ))}
            @click=${() => this.dispatchEvent(new DropDownItemClickEvent())}
            part="dropdown-item"
         >
            <slot>${AtlButtonTemplate({
               variant: ButtonEnums.ButtonVariant.Action,
               iconName: this.iconName,
               fullWidth: true,
               reverseOrder: this.reverseOrder,
               justifyContent: this.justifyContent ?? JustifyContent.Start,
               innerContent: html`${this.dropdownLabel}`,
            })}</slot>
         </div>
      `;
   }
}
